import type { EstadoPresupuestoProforma, ParteItem } from '../types';

/** Espera antes de disparar el guardado automático de un ítem editado. */
export const AUTOGUARDADO_DEBOUNCE_MS = 500;

export const MONTO_MAXIMO = 999999999999.99;

export const PARTES: ParteItem[] = ['adquiriente', 'transferente'];

/**
 * Etiquetas visibles. La terminología del sistema es siempre "adquiriente" y
 * "transferente", nunca comprador ni vendedor.
 */
export const ETIQUETA_CAJA: Record<ParteItem, string> = {
  adquiriente: 'Ítems del adquiriente',
  transferente: 'Ítems del transferente',
};

export const ETIQUETA_PARTE: Record<ParteItem, string> = {
  adquiriente: 'Adquiriente',
  transferente: 'Transferente',
};

export const ETIQUETA_ESTADO: Record<EstadoPresupuestoProforma, string> = {
  borrador: 'Borrador',
  confirmado: 'Confirmado',
  importado: 'Importado',
  archivado: 'Archivado',
};

export const CLASE_ESTADO: Record<EstadoPresupuestoProforma, string> = {
  borrador: 'bg-amber-100 text-amber-800',
  confirmado: 'bg-green-100 text-green-800',
  importado: 'bg-blue-100 text-blue-800',
  archivado: 'bg-slate-100 text-slate-700',
};
